import { sva } from '@repo/pandacss/styled-system/css';

export const summaryTableRecipe = sva({
  slots: ['container', 'table', 'thead', 'tbody', 'mobileHeadRow', 'desktopHeadRow'],
  base: {
    container: {
      borderTopLeftRadius: 'lg',
      borderTopRightRadius: 'lg',
      borderBottomRightRadius: 'lg',
      borderBottomLeftRadius: 'lg',
      overflowX: 'hidden',
      overflowY: 'hidden',
    },
    table: {
      width: 'full',
      borderTopWidth: 'none',
      borderRightWidth: 'none',
      borderBottomWidth: 'none',
      borderLeftWidth: 'none',
      borderTopStyle: 'solid',
      borderRightStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderCollapse: 'collapse',
      borderSpacing: '0',
      minWidth: {
        md: '[775px]',
      },
    },
    thead: {
      backgroundColor: 'transparent',
    },
    tbody: {
      backgroundColor: 'white',
    },
    mobileHeadRow: {
      display: 'none',
    },
    desktopHeadRow: {},
  },
  variants: {
    showMobileLayout: {
      true: {
        container: {
          borderTopWidth: { base: 'thin', sm: 'none' },
          borderRightWidth: { base: 'thin', sm: 'none' },
          borderBottomWidth: { base: 'thin', sm: 'none' },
          borderLeftWidth: { base: 'thin', sm: 'none' },
          borderTopStyle: { base: 'solid' },
          borderRightStyle: { base: 'solid' },
          borderBottomStyle: { base: 'solid' },
          borderLeftStyle: { base: 'solid' },
          borderTopColor: { base: 'neutral.lighter2', sm: 'transparent' },
          borderRightColor: { base: 'neutral.lighter2', sm: 'transparent' },
          borderBottomColor: { base: 'neutral.lighter2', sm: 'transparent' },
          borderLeftColor: { base: 'neutral.lighter2', sm: 'transparent' },
          borderTopLeftRadius: 'lg',
          borderTopRightRadius: 'lg',
          borderBottomLeftRadius: { base: '[0]', sm: 'lg' },
          borderBottomRightRadius: { base: '[0]', sm: 'lg' },
          overflowX: { base: '[visible]', sm: 'hidden' },
          overflowY: { base: '[visible]', sm: 'hidden' },
        },
        thead: {
          backgroundColor: { base: 'neutral.lightest', sm: 'transparent' },
        },
        mobileHeadRow: {
          display: { base: 'table-row', sm: 'none' },
        },
        desktopHeadRow: {
          display: { base: 'none', sm: 'table-row' },
        },
      },
    },
  },
});
